import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f0dd8904&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=f0dd8904&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dd8904",
  null
  
)

export default component.exports